import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

import { Box, Button, Container, Slide } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'

import { InnerContentBox, MenuBox, StyledPaper } from 'artkive/components/Navbar/MobileMenu/MobileMenu.style'
import { useLockBodyScroll } from 'artkive/components/Navbar/MobileMenu/useLockBodyScroll'
import { withClickTracker } from 'artkive/components/Tracker'
import { GET_BOX_CLICK, REFERRAL_MODAL } from 'artkive/constants/tracker/mainNavigation'
import useReferralCta from 'artkive/hooks/useReferralCta'
import useSale from 'artkive/hooks/useSale'
import routes from 'artkive/utils/routes'

import bubbles from 'images/ecom/get-started/bubbles.png'

import AccentLink from '../AccentLink'

import MenuLink from './MenuLink'

const TrackAccentLink = withClickTracker(AccentLink)

export const MOBILE_MENU_ID = 'mobile-menu'

const useStyles = makeStyles(() => ({
  icon: {
    fontSize: 24,
  },
  getStartedWrapper: {
    position: 'relative',
    zIndex: 1,
    '&::before': {
      position: 'absolute',
      content: '" "',
      background: `url(${bubbles}) no-repeat`,
      backgroundSize: '99px 192px',
      transform: 'scaleX(-1)',
      width: 99,
      height: 192,
      left: -56,
      top: 0,
      zIndex: 0,
    },
    '&::after': {
      position: 'absolute',
      content: '" "',
      background: `url(${bubbles}) no-repeat`,
      backgroundSize: '99px 192px',
      width: 99,
      height: 192,
      right: -58,
      top: 0,
      zIndex: 0,
    },
  },
}))

const MobileMenu = ({ isOpen, onNavigate }) => {
  const classes = useStyles()
  const openReferralModal = useReferralCta()
  const { isSale, name, priceLabel, boxCheckoutUrl } = useSale()

  const handleGet20Click = useCallback(
    (event) => {
      onNavigate?.(event)
      openReferralModal(event)
    },
    [onNavigate, openReferralModal],
  )

  useLockBodyScroll(isOpen)

  return (
    <Slide direction='down' in={isOpen} style={{ zIndex: 1091 }}>
      <MenuBox id={MOBILE_MENU_ID}>
        <StyledPaper elevation={0} square>
          <Container>
            <InnerContentBox>
              <Box mb={2}>
                <MenuLink href={routes.books}>Kids Art Books</MenuLink>
              </Box>
              <Box mb={2}>
                <MenuLink href={routes.mosaics}>Framed Mosaics</MenuLink>
              </Box>
              <Box mb={2}>
                <MenuLink href={routes.pricing}>Pricing</MenuLink>
              </Box>
              <Box mb={2}>
                <MenuLink href={routes.ourProcess}>Our Process</MenuLink>
              </Box>
              <Box mb={2}>
                <MenuLink href={routes.giftCards}>Gift Cards</MenuLink>
              </Box>
              <Box mb={2}>
                <MenuLink href={routes.blog} target='_blank'>
                  Blog
                </MenuLink>
              </Box>
              <Box mb={5}>
                {isSale ? (
                  <TrackAccentLink
                    href={boxCheckoutUrl}
                    trackerEvent={GET_BOX_CLICK}
                    trackerOptions={{ section: 'mobile_menu_sale_button' }}
                  >
                    {name}
                  </TrackAccentLink>
                ) : (
                  <TrackAccentLink key='get-20' onClick={handleGet20Click} trackerEvent={REFERRAL_MODAL.CTA_CLICK}>
                    Get $20
                  </TrackAccentLink>
                )}
              </Box>
              <Box mb={2.5}>
                <MenuLink component={Button} size='large' startIcon={<AccountCircleIcon />} href={routes.accountOrders}>
                  My Account
                </MenuLink>
              </Box>
              <Box className={classes.getStartedWrapper} mt={5}>
                <Button color='primary' href={boxCheckoutUrl} variant='contained' size='large' style={{ zIndex: 1 }}>
                  {isSale ? `Get ${priceLabel} Box` : 'Get My Box'}
                </Button>
              </Box>
            </InnerContentBox>
          </Container>
        </StyledPaper>
      </MenuBox>
    </Slide>
  )
}

MobileMenu.propTypes = {
  isOpen: PropTypes.bool,
  onNavigate: PropTypes.func,
}

export default MobileMenu
